import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

const COOKIE_BANNER_CATEGORY = 'cookie_banner';

export const SP_COOKIE_BANNER_EVENTS = {
  ACCEPT_ALL_CLICKED: (label: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: COOKIE_BANNER_CATEGORY,
    label,
    name: 'accept_all',
  }),
  ESSENTIAL_ONLY_CLICKED: (label: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: COOKIE_BANNER_CATEGORY,
    label,
    name: 'essential_only',
  }),
  LEARN_MORE_CLICKED: (url: string, label: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: COOKIE_BANNER_CATEGORY,
    label,
    name: 'learn_more',
    url,
  }),
  LOADED: (label: string) => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: COOKIE_BANNER_CATEGORY,
    label,
    name: 'cookie_banner_loaded',
  }),
};

const COOKIE_POLICY_REMINDER_CATEGORY = 'cookie_policy_reminder';

export const SP_COOKIE_POLICY_REMINDER_EVENTS = {
  LEARN_MORE_CLICKED: (url: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: COOKIE_POLICY_REMINDER_CATEGORY,
    name: 'learn_more',
    url,
  }),
  OKAY_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: COOKIE_POLICY_REMINDER_CATEGORY,
    name: 'okay',
  }),
};
